import birthdayMessageBackground from "../../assets/celebrations/birthdaymessageboxbackground.png";
import { Building2, UserRound } from "lucide-react";

interface BirthdayMessageCardProps {
    name: string;
}

const BirthdayMessageCard = ({ name }: BirthdayMessageCardProps) => {
    return (
        <div className="w-full h-full">

            <div className="h-[35px]" />

            {/* Birthday Banner */}
            <div className="relative rounded-3xl overflow-hidden">
                <img
                    src={birthdayMessageBackground}
                    alt="Birthday Message Background"
                    className="w-full rounded-3xl"
                />

                {/*  Message */}
                <div
                    className="
                        absolute
                        left-1/2
                        bottom-[10%]
                        -translate-x-1/2
                        text-center
                        max-w-2xl
                        px-6
                    "
                >
                    <p className="text-white text-2xl font-medium leading-relaxed">
                        Hope your day is filled with joy, laughter
                        and wonderful moments!
                    </p>
                </div>
            </div>

            {/* Divider */}
            <div className="border-t border-white/10 mt-10 pt-10">

                <div className="grid grid-cols-2 gap-8">

                    {/* From */}
                    <div className="flex items-center gap-4">

                        <div
                            className="
                                w-16 h-16
                                rounded-full
                                bg-gradient-to-br
                                from-purple-600
                                to-indigo-700
                                flex
                                items-center
                                justify-center
                                shadow-lg
                            "
                        >
                            <Building2 className="w-8 h-8 text-white" />
                        </div>

                        <div>
                            <p className="text-gray-400 text-sm">
                                From
                            </p>

                            <p className="text-2xl font-bold text-white">
                                Realm Digital
                            </p>

                            <p className="text-gray-300">
                                Your PowerUp Family
                            </p>
                        </div>

                    </div>

                    {/* To */}
                    <div className="flex items-center gap-4">

                        <div
                            className="
                                w-16 h-16
                                rounded-full
                                bg-gradient-to-br
                                from-fuchsia-600
                                to-purple-700
                                flex
                                items-center
                                justify-center
                                shadow-lg
                            "
                        >
                            <UserRound className="w-8 h-8 text-white" />
                        </div>

                        <div>
                            <p className="text-gray-400 text-sm">
                                To
                            </p>

                            <p className="text-2xl font-bold text-white">
                                {name}
                            </p>
                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
};

export default BirthdayMessageCard;